<template>
  <div class="mobile">
    <button class="button toggle" @click="drawerVisible = true">
      <i class="las la-bars"></i> <span>Menu</span>
    </button>
    <div
      class="right-drawer"
      :style="{
        width: drawerVisible? '45vw' : '0',
        paddingLeft: drawerVisible? '10px' : '0',
      }"
    >
      <div style="text-align:right; margin:5px">
        <button class="button close" @click="drawerVisible = false">
          <i class="las la-times" style="font-size:24px"></i>
        </button>
      </div>
      <ul class="menu">
        <li class="hello">
          <router-link
                active-class="is-active"
                class="link"
                :to="{ name: 'HelloWorld' }">
            <span @click="drawerVisible = false" class="title">Home</span>
          </router-link>
        </li>
        <li class="about">
          <router-link
                active-class="is-active"
                class="link"
                :to="{ name: 'About' }">
            <span @click="drawerVisible = false" class="title">About</span>
          </router-link>
        </li>
        <li class="customer module">
          <router-link
                active-class="is-active"
                class="link module"
                :to="{ name: 'CustomerAttributes' }">
            <span @click="drawerVisible = false" class="title">Customer Attributes</span>
          </router-link>
        </li>
        <li class="cms-transfer module">
          <router-link
                active-class="is-active"
                class="link module"
                :to="{ name: 'CmsTransfer' }">
            <span class="title">CmsTransfer</span>
          </router-link>
        </li>
        <li class="elastic module">
          <router-link
                active-class="is-active"
                class="link module"
                :to="{ name: 'ElasticStatus' }">
            <span @click="drawerVisible = false" class="title">Elastic Status</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div
      class="drawer-mask"
      :style="{
        width: drawerVisible ? '100vw' : '0',
        opacity: drawerVisible ? '0.6' : '0',
      }"
      @click="drawerVisible = false"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Mobile',
  data () {
    return {
      drawerVisible: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@blue: #6AB6BE;
@blue-dark: #65ABB2;
@grey: #646464;
@grey-dark: #3e3e3e;

.right-drawer {
  position: absolute;
  top: 0;
  right: 0;
  width: 0; /* initially */
  overflow: hidden;
  height: 100vh;
  padding-left: 0; /* initially */
  border-left: 1px solid whitesmoke;
  background: @blue-dark;//rgba(60,156,148,1);
  z-index: 200;
  transition: all 0.2s; /* for the animation */
  .la-times::after {
    color: #fff;
    content: 'X';
    font-weight: 900;
  }
  li {
    margin: 0 16px;

    &.module {
      margin-block-start: 30px;
    }

    a {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      position: relative;
      text-decoration: none;

      &:hover { text-decoration: underline }

      &.module {
        &:before {
          color: @grey;
          content: "MODULE";
          font-size: 16px;
          position: absolute;
          top: -24px;
        }
      }
    }
  }
}

.drawer-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 0; /* initially */
  height: 100vh;
  background: #000;
  opacity: 0.3;
  z-index: 199;
}
.mobile {
  display: block;
  @media screen and (min-width: 720px) {
    display: none;
  }
  .button {
    background: @blue-dark;
    border: 0px solid transparent;
    border-radius: 8px;
    color: #fff;
    display: inline-block;
    font-size: 20px;
    font-weight: 700;
    padding: 8px 12px;
    text-decoration: none;

    &:hover { background: @blue-dark }

    &.toggle {
      top: 0;
      position: absolute;
      right: 0;
      margin: 4% 4% 0 0;
    }

    .la-bars::after {
      color: #fff;
      content: '\2261 ';
      font-weight: 900;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue